<div class="loaderContent">
  @if (!this.isLoading2()) {
    <div style="display: flex; justify-content: center; flex-direction: column">
      <div class="light-shade box rounded-corners" style="width: 100%; max-width: 900px; margin-bottom: 10px">
        <div style="padding: 10px; display: flex; justify-content: left; align-items: center; font-size: 14px">
          <div style="display:flex;">
            @if (motoristList) {
              <div style="display: flex">
                <div class="data-label">Motorist ID:</div>
                <div>{{ motoristList }}</div>
              </div>
            }
            @if (plateList) {
              <div style="display: flex">
                <div class="data-label" style="margin-left: 10px">Plate Number:</div>
                <div>{{ plateList }}</div>
              </div>
            }
          </div>
          <div class="data-label" style="margin-left: 10px">Payable</div>
          <div>{{ payableTotal | currency: 'USD':'symbol' }}</div>
        </div>
      </div>

      <div class="light-shade box rounded-corners" style="width: 100%; max-width: 900px; margin-top: 10px">
        <div style="width: 100%" class="title-bar dark-shade box-title rounded-corners-upper">
          <div>{{ ticketListTitle }}</div>
        </div>
        <div style="padding: 10px">
          <app-ticket-select-display
            [ticketList]="ticketPayList"
          (selectionChanged)="selectionChanged($event)"></app-ticket-select-display>
        </div>
      </div>

      <div class="light-shade box rounded-corners" style="width: 100%; max-width: 900px; margin-top: 10px">
        <div style="padding: 10px">
          @if (ticketPayList.length > 0) {
            <div style="margin-left: 10px; margin-bottom: 5px">
              Total Amount to Pay: {{ selectedToPayTotal | currency: 'USD':'symbol' }}, &nbsp;
              {{ selectedToPayCount }} obligation{{ selectedToPayCount === 1 ? '' : 's' }} selected
            </div>
          }
          @if (ticketPayList.length === 0) {
            <div style="margin-left: 10px; margin-bottom: 5px">No tickets to pay</div>
          }
          <div>
            <dx-button
              style="margin-left: 10px"
              text="Back"
              (onClick)="back()"
            icon="{{ env.assetsPath }}images/Previous_16x16.png"></dx-button>
            <dx-button
              style="margin-left: 10px"
              text="Pay Now"
              (onClick)="payTickets()"
              [disabled]="selectedToPayCount === 0"
            icon="{{ env.assetsPath }}images/Next_16x16.png"></dx-button>
            <dx-button
              style="margin-left: 20px"
              text="Select All"
              (onClick)="selectAll()"
              [disabled]="ticketPayList.length === 0"
            icon="{{ env.assetsPath }}images/Check_16x16.png"></dx-button>
          </div>
        </div>
      </div>

      <div class="light-shade box rounded-corners" style="width: 100%; max-width: 900px; margin-top: 10px">
        <div style="width: 100%" class="title-bar dark-shade box-title rounded-corners-upper">
          <div>{{ ticketClosedList.length }} closed ticket{{ ticketClosedList.length > 1 ? 's' : '' }}</div>
        </div>
        <div style="padding: 10px">
          <app-ticket-select-display [ticketList]="ticketClosedList"></app-ticket-select-display>
        </div>
      </div>
    </div>
  } @else {
    <app-loading-div></app-loading-div>
  }
</div>
